import React, { useState } from 'react'
import DocumentModal from '../common/DocumentModal.js'

/**
 * Display shipment booking media (photos + videos) from API `images` / `media`.
 */
const ShipmentMediaGallery = ({
  media,
  title = 'Shipment Photos & Videos',
  className = '',
  emptyMessage = 'No photos or videos attached',
}) => {
  const [modal, setModal] = useState({ open: false, url: '', type: '' })

  const items = Array.isArray(media)
    ? media
    : Array.isArray(media?.images)
      ? media.images
      : []

  const normalized = items
    .map((item, index) => {
      const url = item?.cdn_url || item?.url || item
      if (!url || typeof url !== 'string') return null
      const mime = String(item?.mime_type || '').toLowerCase()
      const mediaType =
        item?.media_type ||
        (mime.startsWith('video/') || /\.(mp4|webm|mov|m4v|3gp)(\?|$)/i.test(url)
          ? 'video'
          : 'photo')
      return { id: item?.id ?? index, url, mediaType, mime }
    })
    .filter(Boolean)

  if (!normalized.length) {
    return emptyMessage ? (
      <p className={`text-sm text-gray-500 ${className}`}>{emptyMessage}</p>
    ) : null
  }

  return (
    <div className={className}>
      {title && (
        <h3 className="text-sm sm:text-base font-semibold text-gray-700 mb-2 sm:mb-3">{title}</h3>
      )}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2 sm:gap-3">
        {normalized.map((item) => (
          <button
            key={`${item.id}-${item.url}`}
            type="button"
            onClick={() =>
              setModal({
                open: true,
                url: item.url,
                type: item.mediaType === 'video' ? 'video' : 'image',
              })
            }
            className="relative aspect-square rounded-xl overflow-hidden border border-gray-200 bg-gray-50 hover:border-orange-400 transition group text-left"
          >
            {item.mediaType === 'video' ? (
              <>
                <video
                  src={item.url}
                  muted
                  playsInline
                  preload="metadata"
                  className="w-full h-full object-cover"
                />
                <span className="absolute inset-0 flex items-center justify-center bg-black/30 text-white text-xs font-semibold">
                  ▶ Video
                </span>
              </>
            ) : (
              <img src={item.url} alt="Shipment media" className="w-full h-full object-cover" />
            )}
          </button>
        ))}
      </div>

      <DocumentModal
        isOpen={modal.open}
        onClose={() => setModal({ open: false, url: '', type: '' })}
        documentUrl={modal.url}
        documentType={modal.type}
        title={modal.type === 'video' ? 'Shipment Video' : 'Shipment Photo'}
      />
    </div>
  )
}

export default ShipmentMediaGallery
